// extracted by mini-css-extract-plugin
export default {"root":"lZIpTnDARl6SSkiKZOKi","placeHolderShimmer":"RHEz5N0c3JqNq8Bdqmjg"};